<div class="modal-header">
  <h2 class="modal-title">{{ edit ? "Edit" : "Create" }} configuration</h2>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.close()">
  </button>
</div>
<div class="modal-body">
  <p>{{ edit ? "Edit the" : "Create a new" }} configuration for the app</p>
  <div class="p-3 bg-gray-50">
    @if (displayDynamicForm) {
      <div class="form-check form-switch right me-3">
        <input class="form-check-input" (click)="toggleView()" type="checkbox" id="toggle-configuration-modal-view">
        <label for="toggle-configuration-modal-view" class="form-check-label">
          {{isSimpleViewActive ? 'Simple' : 'Advanced'}}
        </label>
      </div>
    }
    <form [formGroup]="configurationForm">
      <div class="mb-5 mb-3 bg-white p-3">
        <label for="config-name">Configuration name</label
          ><span class="mandatory-indicator" aria-hidden="true">*</span>
          <input
            type="text"
            class="form-control"
            id="config-name"
            formControlName="name"
            placeholder="New configuration"
          [ngClass]="
            configurationForm.get('name')?.errors &&
            configurationForm.get('name')?.dirty
              ? 'is-invalid'
              : ''
          "/>
            @if (
              configurationForm.get('name')?.errors &&
              configurationForm.get('name')?.dirty &&
              configurationForm.get('name')?.errors?.required
              ) {
              <div
                class="invalid-feedback"
                >
                Configuration name is required
              </div>
            }
          </div>
          @if (canCreateGlobalConfig) {
            <div class="mb-3 p-3 bg-white">
              <p class="form-label">Configuration scope</p>
              <div class="d-flex gap-4">
                <div
                  class="form-check"
                  [ngbTooltip]="edit ? 'You cannot modify the scope after it has been created.' : null"
                  container="body">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="config-scope-organisation"
                    name="configScope"
                    [disabled]="edit"
                    [checked]="selectedScope === ConfigurationCreationScope.ORGANISATION"
                    (change)="onScopeChange(ConfigurationCreationScope.ORGANISATION)">
                  <label class="form-check-label" for="config-scope-organisation">
                    Organization @if (organisationScopeTarget) {({{ organisationScopeTarget }})}
                  </label>
                </div>
                <div
                  class="form-check"
                  [ngbTooltip]="edit ? 'You cannot modify the scope after it has been created.' : null"
                  container="body">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="config-scope-global"
                    name="configScope"
                    [disabled]="edit"
                    [checked]="selectedScope === ConfigurationCreationScope.GLOBAL"
                    (change)="onScopeChange(ConfigurationCreationScope.GLOBAL)">
                  <label class="form-check-label" for="config-scope-global">Global</label>
                </div>
              </div>
            </div>
          }
          <div class="bg-white p-3">
            <ama-ng-app-store-parameter-container
              [edit]="true"
              [isSimpleView]="isSimpleViewActive"
              [displayDynamicForm]="displayDynamicForm"
              [configuration]="configParameters"
              [configurationForm]="configurationForm">
            </ama-ng-app-store-parameter-container>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-primary me-5"
        (click)="activeModal.close()">
        Cancel
      </button>
      <button
        type="button"
        id="save-btn"
        class="btn btn-primary"
        [disabled]="displayDynamicForm && !isSimpleViewActive"
        (click)="onSubmit()">
        {{ edit ? "Save" : "Create" }}
      </button>
    </div>
